import { ShareApp } from "@/features/organization-app";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app-layout/share/$shareAppId")({
  component: ShareAppPage
});

function ShareAppPage() {
  const { shareAppId } = Route.useParams();
  const appSearchParams = Route.useSearch();

  return <ShareApp shareAppId={shareAppId} appSearchParams={appSearchParams} />;
}
